<template>
  <div class="main">
    <my_menu2 page_name="项目数据" back_type="close" back_icon="md-close"></my_menu2>

    <div style="height: 50px"></div>
    <div class="content" v-if="page_auth_show">
      <div>
        <Tabs type="card" v-model="dep_1" @on-click="dep_click_1">
          <TabPane :name="item.value" :label="item.label" v-for="(item, i) in dep_list" :key="i">
            <div class="tabs_dep">
              <Tabs v-model="dep_2" @on-click="dep_click_2">
                <TabPane :name="dep_item.value" :label="dep_item.label" v-for="(dep_item, dep_index) in item.children"
                  :key="dep_index"></TabPane>
              </Tabs>
            </div>
          </TabPane>
        </Tabs>
        <!-- <span >{{ query_date[0].getMonth() }}{{ query_date[1].getMonth() }}数据跨月，本月数据列已隐藏</span> -->
      </div>

      <Spin fix v-if="table_loading">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>玩命加载中..</div>
      </Spin>

      <div class="query_div">
        <div>
          <Select v-model="type_index" filterable style="width: 80px" size="small" @on-change="select_type_change"
            clearable>
            <Option v-for="item in type_list" :value="item.value" :key="item.value">{{
              item.label
            }}</Option>
          </Select>
          <Select v-if="subject_options_list.length > 0" clearable filterable v-model="subject_select_id"
            style="width: 120px; margin-left: 10px" size="small" placeholder="筛选主体" @on-change="select_subject_change">
            <Option v-for="item in subject_options_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Button size='small' v-if="dep_1 == 'all'" @click="search_project" style="font-size:13px;margin-left:10px">
            <Icon type="ios-search-outline" />搜索项目
          </Button>
          <Checkbox style="margin-left: 10px; font-size: 13px" v-model="is_zeero_hide" @on-change="checkbox_zeero_hide">
            隐藏在职为0数据</Checkbox>
        </div>
        <div class="query_div_2">
          <DatePicker v-model="query_date[0]" format="yyyy/MM/dd" type="date" size="small" placeholder="开始日期"
            placement="bottom-end" style="width: 120px" />
          <span>-</span>
          <DatePicker v-model="query_date[1]" format="yyyy/MM/dd" size="small" type="date" placeholder="结束日期"
            placement="bottom-end" style="width: 120px" />

          <Button @click="date_picker_change" style="font-size: 12px; margin-left: 5px" size="small"
            type="primary">筛选</Button>
          <!-- <DatePicker
            format="yyyy/MM/dd"
            v-model="query_date"
            size="small"
            type="daterange"
            placement="bottom-end"
            placeholder="筛选日期"
            style="width: 200px"
            @on-change="date_picker_change"
          /> -->
          <div>
            <span class="export_excel" @click="click_export_data">
              <Icon type="md-cloud-download" color="#0466dd" />导出表格
            </span>
          </div>
        </div>
      </div>

      <div class="table_box">
        <Table :columns="columns" :data="table_data" size="small" :height="windowHeight - 230"
          @scroll="syncScroll('second')" show-summary>
          <template #project_name="{ row }">
            <span @click="click_project_name(row)" class="project_name">{{
              row.project_name
            }}</span>
          </template>
          <template #project_contract_valid_count="{ row }">
            <span class="project_name" @click="click_project_name(row)" v-if="row.project_contract_valid_count > 0">{{
              row.project_contract_valid_count
            }}份有效</span>
            <span class="project_name2" @click="click_project_name(row)" v-else>{{ row.project_contract_valid_count
            }}份有效</span>
          </template>
          <template #zaizhi="{ row }">
            <span class="zaizhi2" @click="click_count_detail('zaizhi', row.zaizhi_list)">{{ row.zaizhi }}</span>
            <!-- 单日范围 -->
            <span v-if="query_date">
              <span v-if="
                query_date[1].getTime() / 1000 - query_date[0].getTime() / 1000 ===
                86400
              ">
                <Icon class="jiaoyan_icon" type="ios-checkmark-circle-outline" color="green"
                  v-if="row.zaizhi == row.yesterday_zaizhi + row.ruzhi - row.lizhi" :title="'等式成立:' +
                    String(row.yesterday_zaizhi) +
                    '+' +
                    String(row.ruzhi) +
                    '-' +
                    String(row.lizhi)
                    " />
                <Icon class="jiaoyan_icon" type="ios-close-circle" color="red" v-else :title="'等式不成立:' +
                  String(row.yesterday_zaizhi) +
                  '+' +
                  String(row.ruzhi) +
                  '-' +
                  String(row.lizhi)
                  " />
              </span>
              <Icon class="jiaoyan_icon" type="ios-alert-outline" color="grey" title="最后一天的在职数，时间范围筛选不校验等式" v-else />
            </span>
          </template>
          <template #need="{ row }">
            <span class="need_count">{{ row.need }}</span>
          </template>
          <template #yaoyue="{ row }">
            <span class="zaizhi2" @click="click_count_detail('yaoyue', row.yaoyue_list)">{{ row.yaoyue }}</span>
          </template>
          <template #mianshi="{ row }">
            <span class="zaizhi2" @click="click_count_detail('mianshi', row.mianshi_list)">{{ row.mianshi }}</span>
          </template>
          <template #mianshi_tongguo="{ row }">
            <span class="zaizhi2" @click="click_count_detail('mianshi_tongguo', row.mianshi_tongguo_list)">{{
              row.mianshi_tongguo }}</span>
          </template>
          <template #mianshi_butongguo="{ row }">
            <span class="zaizhi2" @click="click_count_detail('mianshi_butongguo', row.mianshi_butongguo_list)">{{
              row.mianshi_butongguo }}</span>
          </template>
          <template #ruzhi="{ row }">
            <span class="zaizhi2" @click="click_count_detail('ruzhi', row.ruzhi_list)">{{
              row.ruzhi
            }}</span>
          </template>
          <template #lizhi="{ row }">
            <span class="zaizhi2" @click="click_count_detail('lizhi', row.lizhi_list)">{{
              row.lizhi
            }}</span>
          </template>
        </Table>
      </div>
      <!-- <div class="heji_div">
        <div
          class="heiji_box"
          v-for="(item, i) in columns"
          :key="i"
          :style="'width:' + item.width + 'px'"
        >
          <div v-if="i == 0" class="heji_small_div">合计</div>
          <div v-if="i == 1" class="heji_small_div">--</div>
          <div v-if="i == 2" class="heji_small_div">--</div>

          <div v-if="i == 3" class="heji_small_div2">
            {{ total_data.zaizhi }}
          </div>
          <div v-if="i == 4" class="heji_small_div3">
            {{ total_data.need }}
          </div>
          <div v-if="i == 5" class="heji_small_div">
            {{ total_data.yaoyue }}
          </div>
          <div v-if="i == 6" class="heji_small_div">
            {{ total_data.mianshi }}
          </div>
          <div v-if="i == 7" class="heji_small_div">
            {{ total_data.mianshi_tongguo }}
          </div>
          <div v-if="i == 8" class="heji_small_div">
            {{ total_data.mianshi_butongguo }}
          </div>
          <div v-if="i == 9" class="heji_small_div">
            {{ total_data.ruzhi }}
          </div>
          <div v-if="i == 10" class="heji_small_div">
            {{ total_data.lizhi }}
          </div>
        </div>
      </div> -->
    </div>

    <Modal v-model="export_data_show" title="导出表格" :footer-hide="true" width="500">
      <Spin fix v-if="loading_export"></Spin>
      <div class="export_modal_txt">导出小提示：导出时请记得选择全部数据，并取消隐藏在职0数据，然后筛选后再点击导出，否则数据可能不一致！</div>
      <div class="export_data_field">

        <div class="export_field">文件包含：</div>
        <div class="export_table_txt">
          <div class="export_tag">数字列表</div>
          <div class="export_tag">面试操作表</div>
          <div class="export_tag">面试通过表</div>
          <div class="export_tag">面试不通过表</div>
          <div class="export_tag">入职表</div>
          <div class="export_tag">离职表</div>
          <div class="export_tag">在职花名册</div>
          <div class="export_tag">离职花名册</div>
          <div class="export_tag">招聘结算表</div>
        </div>
        <!-- <Select v-model="export_data_select" style="width:200px" size="small">
                                        <Option v-for="item in export_data_select_options" :value="item.value" :key="item.value">{{
                                            item.label
                                        }}</Option>
                                    </Select> -->
      </div>
      <!-- <div class="export_data_field">
        <div class="export_field">选择时间：</div>
        <DatePicker
          format="yyyy/MM/dd"
          v-model="export_date"
          size="small"
          type="daterange"
          placement="bottom-end"
          placeholder="筛选日期"
          style="width: 200px"
        />
      </div> -->
      <div class="totp">
        <div class="export_field">动态验证码：</div>
        <div>
          <Input v-model="totp_value" placeholder="大象系统动态码" style="width: 150px" />
        </div>
        <div>
          <Poptip trigger="hover" title="大象系统APP>>我的>>2FA动态码" content="content">
            <span class="totp_hint">找不到动态码?</span>
            <template #content>
              <div class="totp_img_div">
                <img style="width:100%;height:100%" src="@/assets/image/auth/totp.png" alt="">
              </div>
            </template>
          </Poptip>
        </div>
      </div>
      <div class="totp_hint_span">
        <Icon type="ios-alert-outline" color="red" size="16" />为了确保数据安全，导出数据需要验证动态码，动态码可在大象系统APP>我的页面中查看
      </div>
      <div class="export_data_field_button">
        <Button style="font-size: 13px" @click="export_ok" type="primary">
          确认导出
        </Button>
      </div>
    </Modal>

    <Drawer title="数据详情" :closable="false" v-model="count_detail_show" width="600">
      <div class="detail_count_div">
        <div class="export_count_detail_div">
          <span @click="export_count_detail">
            <Icon type="ios-cloud-download" />导出表格
          </span>
        </div>
        <Spin fix v-if="count_detail_loading">加载中...</Spin>
        <Table size="small" border :height="windowHeight - 200" ref="count_table" :columns="count_detail_columns"
          :data="count_detail_table_data"></Table>
      </div>
    </Drawer>

    <Modal v-model="search_project_show" title="搜索项目" :footer-hide="true" width="400">
      <Input v-model="search_project_name" search enter-button placeholder="请输入项目..." @on-search='date_picker_change'
        @on-clear="date_picker_change" @on-click="date_picker_change" @on-enter="date_picker_change"
        style="width: 300px" />
    </Modal>
  </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";

export default {
  components: {
    my_menu2,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      //部门数据
      dep_list: [],
      dep_1: "",
      dep_2: "",

      //系统列表
      table_data: [],
      columns: [],

      table_loading: false,

      export_data_show: false,

      export_data_select_options: [
        {
          value: "mianshi",
          label: "面试表",
        },
      ],
      export_data_select: "",
      query_date: [],
      export_date: [],
      loading_export: false,

      //合计数据
      total_data: {},

      type_list: [],
      type_index: -1,

      order_key: "",
      order_status: "desc",
      is_zeero_hide: false,

      count_detail_show: false,
      count_detail_table_data: [],
      count_detail_columns: [],
      count_detail_loading: false,

      page_auth_show: true,

      subject_options_list: [],
      subject_select_id: -1,
      totp_value: "",
      search_project_show: false,
      search_project_name: ""
    };
  },

  mounted() {
    this.window_change();

    var stamp1 = new Date(new Date().setHours(0, 0, 0, 0)); //获取当天零点的时间
    var stamp2 = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000);

    this.query_date = [stamp1, stamp2];
    this.export_date = [stamp1, stamp2];

    // 获取部门数据
    this.get_dep_options();
    this.get_project_type();
    this.get_subject_options();
  },

  methods: {
    search_project() {
      this.search_project_show = true
    },

    select_subject_change(e) {
      console.log(e);
      this.subject_select_id = e;
      this.get_table_data();
    },

    syncScroll(e) {
      console.log(e);
    },

    export_count_detail() {
      this.$refs.count_table.exportCsv({
        filename: "导出表格",
      });
    },

    click_count_detail(status, interview_list) {
      this.count_detail_show = true;

      this.get_count_detail_data(status, interview_list);
    },

    get_count_detail_data(status, interview_list) {
      var that = this;
      var obj = {
        status: status,
        interview_id_list: interview_list,
      };
      that.count_detail_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/xiangmu/interview_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.count_detail_table_data = res.data.data_list;
            that.count_detail_columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.count_detail_loading = false;
        })
        .catch((res) => {
          that.count_detail_loading = false;

          console.log(res, "请求出错");
        });
    },

    select_type_change(e) {
      console.log(e);
      this.get_table_data();
    },

    export_ok() {
      var that = this;

      var obj = {
        dep_id_list: [this.dep_1, this.dep_2],
        // start_time: this.export_date[0].getTime() / 1000,
        // end_time: this.export_date[1].getTime() / 1000,
        start_time: this.query_date[0].getTime() / 1000,
        end_time: this.query_date[1].getTime() / 1000,
        project_type: this.type_index,
        table_data: this.table_data,
        totp_code: that.totp_value
      };
      this.loading_export = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/xiangmu/export_data",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var url = res.data.url;

            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.$Modal.confirm({
              title: "提示",
              content: "导出完成，为防止下载被拦截，请点击确认开始下载文件",
              onOk: () => {
                // open_new_page(url);
                var object_name = res.data.object_name
                get_view_file_url(object_name)
              },
              onCancel: () => {
                that.$Message.info("下载已取消");
              },
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading_export = false;
        })
        .catch((res) => {
          that.loading_export = false;
          console.log(res, "请求出错");
        });
    },

    get_project_type() {
      var that = this;
      var obj = {};

      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/xiangmu/project_type_options",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.type_list = res.data.type_list;
            // that.type_index = res.data.type_list[res.data.type_list.length - 1]["value"];
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_subject_options() {
      var that = this;
      var obj = {};

      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/xiangmu/subject_options",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.subject_options_list = res.data.data_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_export_data() {
      this.export_data_show = true;
    },

    //点击部门
    dep_click_2(e) {
      // 获取部门数据
      this.get_table_data();
    },

    dep_click_1(e) {
      this.dep_1 = e;
      for (let i = 0; i < this.dep_list.length; i++) {
        var dep_id = this.dep_list[i]["value"];
        if (dep_id == e) {
          this.dep_2 = this.dep_list[i]["children"][0]["value"];
          console.log(this.dep_2);
          this.get_table_data();

          return;
        }
      }
    },

    get_dep_options() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/xiangmu/dep_options",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.dep_list = res.data.data_list;

            if (that.dep_list.length == 0) {
              this.$Message.info("当前没有可用的项目权限");
              this.page_auth_show = false;

              return;
            } else {
              this.page_auth_show = true;
              this.dep_1 = that.dep_list[0]["value"];
              this.dep_2 = that.dep_list[0]["children"][0]["value"];

              // 获取数据
              // that.get_table_data();
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //时间筛选变化
    date_picker_change(e) {
      console.log(e);
      this.table_data = [];
      this.get_table_data();
      this.search_project_show = false

    },

    //获取表格数据
    get_table_data() {
      var that = this;
      this.table_loading = true;
      var obj = {
        start_time: this.query_date[0].getTime() / 1000,
        end_time: this.query_date[1].getTime() / 1000,
        dep_id: this.dep_2,
        dep_team_id: this.dep_1,
        project_type: this.type_index,
        order_key: this.order_key,
        order_status: this.order_status,
        is_zeero_hide: this.is_zeero_hide,
        subject_id: this.subject_select_id,
        project_name: this.search_project_name
      };
      http("post", process.env.VUE_APP_HOST + "/data_panel/xiangmu/dep_data", obj, true)
        .then((res) => {
          if (res.code == 0) {
            console.log(res)
            that.columns = res.data.columns;
            that.table_data = res.data.table_data;
            that.total_data = res.data.total_data;
            that.search_project_name = ''

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          this.table_loading = false;
        })
        .catch((res) => {
          this.table_loading = false;
          console.log(res, "请求出错");
        });
    },

    click_project_name(row) {
      var url =
        "/workbench/my_project?project_id=" +
        row.project_id +
        "&project_name=" +
        row.project_name;
      open_new_page(url);
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },

    checkbox_zeero_hide() {
      this.get_table_data();
    },


  },
};
</script>

<style scoped>
.totp_hint_span {
  font-size: 13px;
  color: #dd0404;
}

.totp_hint {
  font-size: 13px;
  margin-left: 10px;
  color: #ccc;
  cursor: pointer;
}

.totp_hint:hover {
  color: #0466dd
}

.totp_img_div {
  width: 200px;
  height: 400px;
  ;
}

.totp {
  display: flex;
  align-items: center;
}

.export_modal_txt {
  padding: 10px;
  font-size: 13px;
  border-bottom: 1px solid #ececec;
  margin-bottom: 10px;
}

.demo-spin-col .circular {
  width: 25px;
  height: 25px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.export_count_detail_div {
  margin-bottom: 10px;
  font-size: 13px;
  display: flex;
  justify-content: flex-end;
  color: #0466dd;
  cursor: pointer;
}

.detail_count_div {
  position: relative;
}

.jiaoyan_icon {
  margin-left: 3px;
  cursor: pointer;
}

.project_name {
  cursor: pointer;
  color: #0466dd;
}

.project_name2 {
  cursor: pointer;
  color: #dd0404;
}

.heji_small_div {
  padding: 0 10px 0 18px;
  font-weight: 600;
  color: rgb(0, 0, 0);
}

.heji_small_div2 {
  font-weight: 600;
  padding: 0 10px 0 18px;
  color: rgb(0, 0, 0);
}

.zaizhi2 {
  color: #0466dd;
  cursor: pointer;
}

.zaizhi2:hover {
  font-weight: 600;
}

.heji_small_div3 {
  font-weight: 600;
  padding: 0 10px 0 18px;
  color: rgb(0, 0, 0);
}

.need_count {
  /* font-weight: 600; */
  color: rgb(65, 163, 4);
}

.heiji_box {
  border-bottom: 1px solid rgb(224, 224, 224);
  background-color: #f5f7f9;
  padding: 3px 0;
  height: 26px;
  flex-shrink: 0;
}

.heji_div {
  overflow-y: auto;
  display: flex;
  align-items: center;
  /* padding: 0 10px; */
  margin: 0 10px;
  font-size: 13px;
  color: #666;
}

.export_tag {
  padding: 2px 5px;
  font-size: 12px;
  color: rgb(255, 255, 255);
  background-color: #9bc2e7;
  border-radius: 2px;
  margin: 0 5px 3px 0;
}

.export_table_txt {
  font-size: 12px;
  color: #333;
  display: flex;
  flex-wrap: wrap;
}

.export_data_field_button {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}

.export_field {
  width: 90px;
  flex-shrink: 0;
  font-size: 13px;
}

.export_data_field {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.export_excel {
  font-size: 13px;
  cursor: pointer;
  margin: 0 10px;
  color: #0466dd;
}

.query_div_2 {
  display: flex;
  justify-content: space-between;
}

.table_box {
  padding: 0 10px;
}

.tabs_dep {
  padding: 0 10px;
}

.table_box_inner {
  height: calc(100vh - 100px);
  overflow: auto;
}

.query_div {
  display: flex;
  justify-content: space-between;
  padding: 0 10px 5px 10px;
}

.table_line {
  padding: 5px 10px;
  display: flex;
  align-items: center;
  background-color: #0466dd;
  color: #fff;
  font-size: 13px;
}

.dep_name {
  width: 120px;
}

.block_div {
  display: flex;
  margin-bottom: 3px;
  padding: 3px;

  border-bottom: 1px solid rgb(249, 248, 248);
}

.table_block {
  width: 80px;
  flex-shrink: 0;
}

.table_block2 {
  width: 80px;
  color: #0466dd;
  cursor: pointer;
  flex-shrink: 0;
}

.dep_box {
  display: flex;
  align-items: center;
  margin: 10px 0;
  font-size: 13px;
  padding: 10px;
  border: 1px solid rgb(241, 241, 241);
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  background-color: #fff;
  overflow: auto;
  position: relative;
  height: calc(100vh - 60px);
  margin: 0 10px 10px 10px;
  padding: 5px 10px;
  border-radius: 5px;
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
}
</style>
